// extracted by mini-css-extract-plugin
export default {"modalContentHeading":"paymentWarning_modalContentHeading__vwdz7","greyBtn":"paymentWarning_greyBtn__nTboY"};